module.exports = __webpack_public_path__ + "static/media/bigticket-logo@3x.29774991.png";